<template>
  <div
    class="countdownv2_holder "
    data-insert-date="2020-10-28 00:00:00"
    data-unique-id="countdown_5f968ecd5dd55"
    data-countdown-direction="false"
    data-date-format-redux="DHMS"
    v-if="days !== 0 || hours !== 0 || minutes !== 0 || seconds !== 0"
  >
    <div class="countdownv2 clock  is-countdown" id="countdown_5f968ecd5dd55">
      <span class="countdown-row countdown-show4">
        <span class="countdown-section" v-if="days">
          <span class="countdown-amount">{{ days | formatTime }}</span>
          <span class="countdown-period">{{ $t("attr.days") }}</span>
        </span>
        <span class="countdown-section" v-if="hours">
          <span class="countdown-amount">{{ hours | formatTime }} </span
          ><span class="countdown-period">{{ $t("attr.hours") }}</span></span
        ><span class="countdown-section"
          ><span class="countdown-amount">{{ minutes | formatTime }}</span
          ><span class="countdown-period">{{ $t("attr.minutes") }}</span></span
        ><span class="countdown-section"
          ><span class="countdown-amount">{{ seconds | formatTime }}</span
          ><span class="countdown-period">{{ $t("attr.seconds") }}</span></span
        ></span
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    deadline: {
      type: String,
    },
    startDate: {
      type: String,
    },
    duration: {
      type: Number,
      required: true,
    },
    speed: {
      type: Number,
      default: 1000,
    },
  },
  data() {
    return {
      currentTime: null,
      timerInterval: null,
    };
  },
  methods: {
    countdown() {
      if (this.deadline) {
        this.currentTime = Date.parse(this.deadline) - Date.parse(new Date());
      }

      if (this.startDate) {
        this.currentTime = Date.parse(this.startDate);
      }

      this.currentTime += 1000 * 60 * 60 * 24 * this.duration;
      if (this.currentTime > 0) {
        setTimeout(this.countdown, this.speed);
      } else {
        this.currentTime = null;
      }
    },
  },
  computed: {
    seconds() {
      return Math.floor((this.currentTime / 1000) % 60);
    },
    minutes() {
      return Math.floor((this.currentTime / 1000 / 60) % 60);
    },
    hours() {
      return Math.floor((this.currentTime / (1000 * 60 * 60)) % 24);
    },
    days() {
      return Math.floor(this.currentTime / (1000 * 60 * 60 * 24));
    },
  },
  mounted() {
    setTimeout(this.countdown, 1000);
  },
  filters: {
    formatTime(value) {
      if (value < 10) {
        return "0" + value;
      }
      return value;
    },
  },
};
</script>
